export default [
  {
    path: "/informes",
    component: () => import("@/layout/Layout1"),
    children: [
      {
        path: "/informes/list",
        component: () => import("@/views/informes/ListInformes"),
        meta: {
          title: "Lista de Informes"
        }
      },
      {
        path: "/informes/add",
        component: () => import("@/views/informes/AddEditInforme"),
        meta: {
          title: "Agregar Informe"
        }
      },
      {
        path: "/informes/edit/:id",
        component: () => import("@/views/informes/AddEditInforme"),
        meta: {
          title: "Editar Informe"
        }
      },
      {
        path: "/informes/detail/:id",
        component: () => import("@/views/informes/InformeDetail"),
        meta: {
          title: "Detalle del Informe"
        }
      }
    ]
  }
];
